import { PAGES_TO_INCLUDE_FOR_APPLE_PAY } from '@constants/applePay';

import { useRouter } from 'next/router';

const useIsApplePayEnabled = (): boolean => {
  const router = useRouter();

  const isApplePayEnabled = PAGES_TO_INCLUDE_FOR_APPLE_PAY.includes(
    router.pathname,
  );

  return isApplePayEnabled;
};

export default useIsApplePayEnabled;
